// extracted by mini-css-extract-plugin
export default {"default":"RolListaScreen_default__a-cIr","dark":"RolListaScreen_dark__oWhaf","dark-mode":"RolListaScreen_dark-mode__oLjbB"};